module.exports = __webpack_public_path__ + "img/kpdf.4f1cd479.png";